import Rest from '../Rest';

export default class AccountService extends Rest {

    static resource = '/accounts';

    async create(accountData) {

        return await this.post(`/`, accountData);

    }


}